import { css } from '@emotion/css';
import { BorderRadius, Color, Font, FontWeight, ScreenBreakpoint, Spacing, TextAlign } from 'src/styles';

export const title = css`
  ${FontWeight.bold}
  ${Font.h5}
  color: ${Color.Gray7};
`;

export const refresh = css`
  ${Font.md}
  ${TextAlign.right}
  color: ${Color.Brand6};
  cursor: pointer;

  .anticon {
    ${Font.md}
  }
`;

export const disclaimer = css`
  ${FontWeight.normal}
  ${Font.sm}
  color: ${Color.Brand6};
  cursor: pointer;
`;

export const dataRow = css`
  background: ${Color.Gray2};
  ${BorderRadius.xxs}
  ${FontWeight.semibold}
  ${Font.lg}
  ${Spacing.p12}
  ${Spacing.pl8}
  i {
    cursor: pointer;
    ${Font.xs}
  }
  @media (max-width: ${ScreenBreakpoint.mobile.min}) {
    ${Spacing.px0}
    ${Spacing.py12}
  }
  @media (max-width: ${ScreenBreakpoint.mobile.max}) {
    ${Spacing.px4}
    ${Spacing.py12}
  }
`;

export const errorInfo = css`
  ${Font.h6}
  color: ${Color.Red6};
  cursor: default !important;
`;

export const popoverWrapper = css`
  width: 200px;
`;
